import { useQuery } from '@apollo/client';

import { useApplicationContext } from '../../../core/contexts/ApplicationContext.tsx';
import { GET_AGENTS } from '../../../products/assistants/queries.ts';
import { canSeeAgents } from '../../utils.ts';

export const useAgentsForViewer = (skip = false) => {
    const { user } = useApplicationContext();
    const teamIds = (user?.teams || []).map((team: { id: string }) => team.id);

    // without agent access the backend denies the query; the callers then treat it as "no agents"
    const { data, loading } = useQuery(GET_AGENTS, { skip: skip || !canSeeAgents(user) });

    const agents = (data?.agents || []).filter(
        (agent: { team?: { id: string } }) => agent.team && teamIds.includes(agent.team.id)
    );

    return { agents, loading };
};
